import { ENV_VARS } from '@common/services/env-vars-service';

const APP_ID = ENV_VARS.WORKS_INTERCOM_APP_ID;

window.intercomSettings = {
  app_id: APP_ID,
  custom_launcher_selector: '.messenger-launcher-wrapper__intercom',
  hide_default_launcher: true,
};

export function loadIntercom() {
  if (!APP_ID) {
    return;
  }
  // prettier-ignore
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==='function'){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src=`https://widget.intercom.io/widget/${APP_ID}`;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
}

export function bootIntercom(userAttributes) {
  if (!APP_ID) {
    return;
  }

  userAttributes = {
    ...userAttributes,
    api_base: 'https://api-iam.intercom.io',
    app_id: APP_ID,
  };

  window && window.Intercom && window.Intercom('boot', userAttributes);
}

export function updateIntercom() {
  if (!APP_ID) {
    return;
  }

  window && window.Intercom && window.Intercom('update');
}
